<template>

      <div class="flex">

        <sbspFormList :filterList="filterList1">



              <slot></slot>
        </sbspFormList>

          <div class="menu">

              <img src="@/assets/img/salary/menu.png" @click="show1()">
              <span @click="show1()">自定义筛选条件</span>
              <div v-if="show">
                   <sbspFilterBox :filterLists="filterList2" @isSave="save"></sbspFilterBox>
              </div>
          </div>
          <div class="shadow" v-if="show">

          </div>
      </div>

</template>

<script>
 import sbspFormList from "@/wage-components/sbs-salary-filter/sbsp-form-list.vue"
  import sbspFilterBox from "@/wage-components/sbs-salary-filter/sbsp-filter-box.vue"
  export default {
    name: "sbs-filter-form",
    props: {
        filterList: {
            type: Array,
            default: [],
        }
    },
    components: {
      sbspFilterBox,
      sbspFormList
    },
     watch:{
        filterList1:{//深度监听，可监听到对象、数组的变化
            handler(val, oldVal){
                this.$emit('update:filterList',val);
            },
            deep:true //true 深度监听
        }
    },
    data() {
      return {
          show:false,
          filterList1:[],
          filterList2:[],
      };
    },
    created(){
      this.filterList1 = JSON.parse(JSON.stringify(this.filterList))
    },
    computed: {
      // 计算属性的 getter
      // filterList1: function () {
      //   // `this` 指向 vm 实例
      //    return JSON.parse(JSON.stringify(this.filterList))
      // },
      // filterList2: function () {
      //   // `this` 指向 vm 实例
      //    return JSON.parse(JSON.stringify(this.filterList))
      // },
    },
    methods: {
       show1: function() {
        this.filterList2 = JSON.parse(JSON.stringify(this.filterList))
        this.show = true;
      },
      save(issave){
         this.show = false;
          if(issave){
            this.filterList1 = JSON.parse(JSON.stringify(this.filterList2));
          }
      }

    }
  };
</script>

<style scoped >
    .flex{
        display:flex;
        justify-content: space-between;
        position:relative;
        padding-right: 10px;
        /* flex-wrap: wrap; */
    }

    .menu{
     white-space: nowrap;
     height:28px;
     line-height:28px;

    }
    .menu img{
      margin-right:2px;
          vertical-align: middle;
          cursor: pointer;
    }
    .menu>span{
      font-size:13px;
      font-family:PingFangSC-Medium,PingFang SC;
      font-weight:500;
      color:rgba(64,158,255,1);
      line-height:18px;
          vertical-align: middle;
          cursor: pointer;
    }
    .shadow{
      position:fixed;
      left:0;
      top:0;
      z-index:999;
     background:rgba(0,0,0,1);
    opacity:0.14;
    width:100%;
    height:100%;
    }
    .menu>div{
      width:426px;
      background:rgba(255,255,255,1);
      border-radius:8px;
      position:absolute;
      z-index:1000;
      right:0;
      padding:10px 0 30px;
      box-sizing:border-box;
      margin-top: 10px;
    }
    .menu>div .menuTop{
          border-bottom: 4px solid #eee;
          padding:0 20px;
    }
    .menu>div .menuTop span{
      padding:0 6px;
      background:rgba(238,238,238,1);
      border-radius:2px;
      display:inline-block;
      height:34px;
      line-height:34px;
      margin-right:15px;
      color:rgba(51,51,51,1);
      font-size:13px;
      font-weight:500;
      margin-bottom:15px;
      position:relative;
    }
    .menu>div .menuTop span img{
        position:absolute;
        right:-6px;
        top:-6px;
    }
     .menuCon{
       padding:0 20px;
     }
    .menuCon p{
        font-size:12px;
        font-weight:400;
        color:rgba(252,106,106,1);
        line-height:17px;
        padding-top:10px;
    }
    .form1 .el-form-item{
      margin-bottom:8px;
    }
</style>
